import { UseLoadingAction } from "@/common/composition/loading";
import { once } from "@/fp";
import { Ref, ref } from "@vue/composition-api";
import { OverviewItem, OverviewType } from "./model";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
import { UseTabs } from "@/common/composition/use-tabs";
import { SharedState } from "@/common/state";
import { GEN_AI_SOURCE_ID } from "../sources/ms-365-gen-ai/data/model";
const [loading, set_loading] = UseLoadingAction<"init">(false, "init");

const [tabs, selected_tab, set_selected_tab] = UseTabs<{
  id: OverviewType;
  name: string;
}>(
  [
    {
      id: "InMotion",
      name: "In Motion",
    },
    {
      id: "AtRest",
      name: "At Rest",
    },
    {
      id: "CloudApp",
      name: "Cloud Apps",
    },
    /*  {
      id: "Regulation",
      name: "Regulations",
    }, */
  ],
  0
);

const overview_sources: Ref<OverviewItem[]> = ref([]);
const current_overview: Ref<OverviewItem> = ref({});
const select_current_overview_source = (source: OverviewItem) => {
  current_overview.value = source;
};

const init = once(async () => {
  set_loading(true, "init");
  await data_sources_state.init();
  if (SharedState.in_motion_services_flags.value.is_ms_and_google_org) {
    // hide the existing Google Workspace and Microsoft 365 sources
    data_sources_state.all_sources.value = data_sources_state.all_sources.value.map(
      (d) => {
        if (d.id == "google_workspace" || d.id == "motion_365") {
          return {
            ...d,
            hide_in_sources_modal: true,
            runtime: {
              ...d.runtime,
            },
          };
        }
        return d;
      }
    );
    data_sources_state.all_sources.value.unshift({
      type: "InMotion",
      name: "In Motion 365 and Google Workspace",
      // @ts-ignore
      id: "in_motion_365_and_g_suite",
      hide_in_data_sources: true,
      runtime: {
        is_licensed: true,
        icon: "Events",
        desc: "Combined overview for Microsoft 365 and Google Workspace",
        enabled: true,
      },
    });
  }
  // Microsoft 365 Gen AI Governance is a client-side mock source: it has no
  // backend data source yet, so it is injected the same way the combined
  // "In Motion 365 and Google Workspace" entry above is.
  //
  // Gated on the `ai_interaction` flag. Registering it here rather than hiding
  // it in the selection modal is what makes the flag actually hold: this array
  // is the single source the modal, the source switcher and current_overview
  // all read, so a source that is never registered has no entry point at all.
  // current_overview always initialises to one of the three defaults below, so
  // turning the flag off cannot strand a user on a dashboard they can no
  // longer reach.
  if (SharedState.FeatureHelper.is_enabled("ai_interaction")) {
    data_sources_state.all_sources.value.unshift({
      type: "InMotion",
      name: "Microsoft 365 Gen AI Governance",
      // @ts-ignore
      id: GEN_AI_SOURCE_ID,
      hide_in_data_sources: true,
      runtime: {
        is_licensed: true,
        // the GenAI mark, as in the event lists' application column (task 25233)
        icon: "Sparkles",
        desc: "Governance for Microsoft 365 Copilot and AI agents",
        enabled: true,
      },
    });
  }

  overview_sources.value = data_sources_state.all_sources.value.map((d) => {
    return {
      type: d.type,
      name: d.name,
      // @ts-ignore
      hide_in_sources_modal: d.hide_in_sources_modal || false,
      // @ts-ignore
      hide_in_data_sources: d.hide_in_data_sources || false,
      id: d.id,
      is_licensed: d.runtime.is_licensed,
      icon: d.runtime.icon,
      desc: d.runtime.desc,
      enabled: d.runtime.enabled,
    };
  });
  switch (true) {
    case SharedState.in_motion_services_flags.value.is_google_org_only:
      current_overview.value = overview_sources.value.find(
        (d) => d.id == "google_workspace"
      )!;
      break;
    case SharedState.in_motion_services_flags.value.is_ms_org_only:
      current_overview.value = overview_sources.value.find(
        (d) => d.id == "motion_365"
      )!;
      break;
    default:
      current_overview.value = overview_sources.value.find(
        (d) => d.id == "in_motion_365_and_g_suite"
      )!;

    //overview_sources.value[0];
  }
  set_loading(false, "init");
});

export const state = {
  init,
  loading,
  tabs,
  selected_tab,
  set_selected_tab,
  overview_sources,
  select_current_overview_source,
  current_overview,
};
